import { UPDATE_VIEW, RESTART } from 'actions';
import getQueryParameterByName from 'utils/getQueryParameterByName';

const skipToView = getQueryParameterByName('view');
const skipToResults = getQueryParameterByName('skipToResults');
const viewId = skipToResults ? 'results' : skipToView || 'splash';

export const view = (state = { id: viewId }, { type, id }) => {
  switch (type) {
    case UPDATE_VIEW:
      return Object.assign({}, { id });
    case RESTART:
      return {
        id: 'splash'
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/view.js